const doNothing = () => {
};
const FakeTrackJS = {
    install: doNothing,
    addMetadata: doNothing,
    track: doNothing,
};
export const TrackJS = typeof window === 'undefined' ? FakeTrackJS : require('trackjs').TrackJS;

//# sourceMappingURL=TrackJS.js.map
